import { isSlotOfSize } from "../../../helpers/slotSizes";
import { FAN_TAKEOVER_SIZES } from "../../../helpers/takeoverConsts";

export function isFanTakeoverSize(
  event: googletag.events.SlotRenderEndedEvent,
): boolean {
  if (event.size === null || typeof event.size === "string") {
    return false;
  }

  if (Array.isArray(event.size) && event.size.length >= 2) {
    const [slotRenderedWidth, slotRenderedHeight] = event.size;
    return (
      isSlotOfSize(
        [slotRenderedWidth, slotRenderedHeight],
        FAN_TAKEOVER_SIZES.DESKTOP,
      ) ||
      isSlotOfSize(
        [slotRenderedWidth, slotRenderedHeight],
        FAN_TAKEOVER_SIZES.MOBILE,
      )
    );
  }

  return false;
}
